import { Injectable } from '@angular/core';
import { requestWithToken, requestWithoutToken } from 'src/config';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {

  async fetchSellerProfileDetails(businessName: any) {
    businessName = encodeURIComponent(businessName);
    return requestWithoutToken(
      'GET',
      `/marketplace/seller-profile/${businessName}`
    )
      .then((res) => {
        return res?.data;
      })
      .catch((error) => {
        return error;
      });
  }
  
}
